/**
 * returns the provider details from local storage
 */
function provider() {
    return JSON.parse(localStorage.getItem("provider"));
}
export default provider;